module.exports = __webpack_public_path__ + "static/media/generic-icon.d9ce357d.svg";